export enum TableSessionConfig {
  TablePreferencesSessionKey = "tablePreferences"
}
